export default __webpack_public_path__ + "static/10-d7d6959857c876ec6528872cf007953f.jpg";